/* Grondyke: free gift with purchase.

   Keeps the right gift lines in the cart while something qualifies for them, and takes them back
   out when it stops. Pricing is NOT this script's job: a gift goes in at its normal price and a
   Shopify Buy X Get Y automatic discount takes it to zero. An automatic discount is what makes
   that show in the drawer; a discount CODE only resolves at checkout, so the drawer would quote
   the shopper a price for a gift.

   More than one promo can be live at once. Each one renders its own config block and owns only
   the lines carrying its id in the _gk_gift property, so the loofah giveaway never tidies away a
   solid cologne and the reverse. A line belonging to any promo is ignored when working out what
   qualifies, so a gift can never trigger another gift.

   The cart is a shared resource here. Eurus writes to it from several places and re-renders the
   drawer from the sections it asks for, so this waits for its turn (window.updatingCart and
   xCartHelper.waitForCartUpdate), does its own writes one at a time, and hands the returned
   sections back to the same helper so the drawer never paints a cart that has already moved on.
   The whole cart is read once per pass and every promo's changes go out in one plan, rather than
   each promo racing the others through the same endpoint.

   A shopper who deletes a gift has made a decision, so it stays deleted. What was put in is
   remembered per promo against the qualifying lines underneath it, so deleting one stick out of
   three keeps that one stick gone instead of having it pushed straight back in, and a genuinely
   new qualifying product offers everything again. */
(function () {
  var nodes = document.querySelectorAll('script[data-gk-gift-config]');
  if (!nodes.length) return;

  var PROP = '_gk_gift';
  var STORE = 'gk_gift:';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var PROMOS = [];
  for (var n = 0; n < nodes.length; n++) {
    var cfg;
    try { cfg = JSON.parse(nodes[n].textContent); } catch (e) { continue; }
    if (!cfg || !cfg.id || !cfg.triggers || !cfg.gifts) continue;
    if (!Object.keys(cfg.triggers).length || !Object.keys(cfg.gifts).length) continue;
    PROMOS.push(cfg);
  }
  if (!PROMOS.length) return;

  var busy = false, again = false;

  function post(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function helper() {
    var A = window.Alpine;
    try { return (A && A.store && A.store('xCartHelper')) || null; } catch (e) { return null; }
  }

  function sectionIds() {
    var h = helper();
    try { return h ? h.getSectionsToRender().map(function (s) { return s.id; }) : []; } catch (e) { return []; }
  }

  function rerender(res) {
    var h = helper();
    try { if (h && res && res.sections) h.reRenderSections(res.sections); } catch (e) { /* the cart is right even if the paint is late */ }
  }

  /* Eurus sets window.updatingCart around its own writes. Starting on top of one loses either
     its change or ours, so wait it out rather than queueing a conflict. */
  function settled() {
    var tries = 0;
    return new Promise(function (resolve) {
      (function wait() {
        if (!window.updatingCart || tries++ > 40) return resolve();
        setTimeout(wait, 100);
      })();
    }).then(function () {
      var h = helper();
      try { return h && h.waitForCartUpdate ? h.waitForCartUpdate() : null; } catch (e) { return null; }
    });
  }

  function ownerOf(item) {
    return (item && item.properties && item.properties[PROP]) || '';
  }

  function isAnyGift(item) {
    return !!ownerOf(item);
  }

  /* What a promo's cart qualifies for, in the order the qualifying lines were added. A promo that
     triggers on a variant looks the line up by variant, which is how a 5 pack of soap qualifies
     where a single bar of the same soap does not. */
  function wanted(promo, items) {
    var keys = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (isAnyGift(it)) continue;
      var lookup = promo.match === 'variant' ? String(it.variant_id) : String(it.product_id);
      var k = promo.triggers[lookup];
      if (!k) continue;
      if (!promo.gifts[k]) k = promo.fallback;
      if (k && promo.gifts[k] && keys.indexOf(k) === -1) keys.push(k);
    }
    if (promo.scope !== 'profile' && promo.scope !== 'each') keys = keys.slice(0, 1);
    return keys.map(function (k) { return promo.gifts[k]; });
  }

  function readState(promo) {
    try {
      var raw = sessionStorage.getItem(STORE + promo.id);
      var v = raw ? JSON.parse(raw) : null;
      if (v && Object.prototype.toString.call(v.given) === '[object Array]') return v;
    } catch (e) {}
    return { given: [] };
  }

  function writeState(promo, state) {
    try { sessionStorage.setItem(STORE + promo.id, JSON.stringify(state)); } catch (e) {}
  }

  function clearState(promo) {
    try { sessionStorage.removeItem(STORE + promo.id); } catch (e) {}
  }

  function planFor(promo, items) {
    var mine = items.filter(function (it) { return ownerOf(it) === promo.id; });
    var want = wanted(promo, items);

    /* Nothing qualifies: take back anything this promo put in. */
    if (!want.length) {
      clearState(promo);
      return { drop: mine, fix: [], add: [] };
    }

    var state = readState(promo);
    /* What was given is remembered per gift, not per cart. Pruning it to what still qualifies is
       the whole rule: a gift whose trigger has left is forgotten, so putting that product back
       offers it again, while a gift the shopper deleted stays declined even as the rest of the
       cart changes around it. Keying this on the cart as a whole meant removing one 5 pack
       resurrected a stick that had been turned down for an entirely different scent. */
    state.given = state.given.filter(function (id) { return want.indexOf(id) !== -1; });

    var keep = [];
    want.forEach(function (id) {
      for (var i = 0; i < mine.length; i++) {
        if (mine[i].variant_id === id && keep.indexOf(mine[i]) === -1) { keep.push(mine[i]); return; }
      }
    });

    var drop = mine.filter(function (g) { return keep.indexOf(g) === -1; });
    /* A gift line is one unit, whatever the quantity stepper was used for. */
    var fix = keep.filter(function (g) { return g.quantity !== 1; });

    var add = want.filter(function (id) {
      if (keep.some(function (g) { return g.variant_id === id; })) return false;
      /* It was given while this same product qualified and is not here now. That was the shopper. */
      return state.given.indexOf(id) === -1;
    });

    /* Whatever is in the cart under this promo counts as given, including on a fresh page load,
       so a later deletion is respected even across a reload. */
    keep.forEach(function (g) {
      if (state.given.indexOf(g.variant_id) === -1) state.given.push(g.variant_id);
    });
    writeState(promo, state);

    return { drop: drop, fix: fix, add: add, state: state };
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    settled()
      .then(function () {
        return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var drop = [], fix = [], add = [];

        PROMOS.forEach(function (promo) {
          var p = planFor(promo, items);
          p.drop.forEach(function (g) { drop.push(g.key); });
          p.fix.forEach(function (g) { fix.push(g.key); });
          p.add.forEach(function (id) { add.push({ promo: promo, id: id }); });
        });

        if (!drop.length && !fix.length && !add.length) return null;

        var ids = sectionIds();
        var chain = drop.reduce(function (c, key) {
          return c.then(function () {
            return post('cart/change.js', { id: key, quantity: 0, sections: ids, sections_url: window.location.pathname });
          });
        }, Promise.resolve(null));

        chain = fix.reduce(function (c, key) {
          return c.then(function () {
            return post('cart/change.js', { id: key, quantity: 1, sections: ids, sections_url: window.location.pathname });
          });
        }, chain);

        return chain.then(function (res) {
          if (!add.length) return res;
          return post('cart/add.js', {
            items: add.map(function (entry) {
              var props = {};
              props[PROP] = entry.promo.id;
              return { id: entry.id, quantity: 1, properties: props };
            }),
            sections: sectionIds(),
            sections_url: window.location.pathname
          }).then(function (added) {
            /* A sold-out gift must never block the cart: leave the rest of it as it is. The ids
               are not recorded as given either, so the next pass can try again. */
            if (added && added.status && added.status >= 400) return res;
            add.forEach(function (entry) {
              var state = readState(entry.promo);
              if (state.given.indexOf(entry.id) === -1) {
                state.given.push(entry.id);
                writeState(entry.promo, state);
              }
            });
            return added;
          });
        });
      })
      .then(function (res) { if (res) rerender(res); })
      .catch(function () { /* the cart stands as it is; the discount simply will not apply */ })
      .then(function () {
        busy = false;
        if (again) { again = false; setTimeout(sync, 60); }
      });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 250);
  }

  document.addEventListener('eurus:cart:items-changed', schedule);
  document.addEventListener('eurus:product:added', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
